/**
 * Bottle card component for mobile view
 */

import { Button } from '../common';
import { formatCurrency, formatProof, formatAge } from '../../utils/formatters';
import './BottleCard.css';

/**
 * Card displaying bottle information
 * @param {Object} props - Component props
 * @param {Object} props.bottle - Bottle data
 * @param {Function} props.onClick - Click handler
 * @param {Function} props.onViewImages - View images handler
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onDelete - Delete handler
 * @returns {React.ReactElement} Card element
 */
export default function BottleCard({
  bottle,
  onClick,
  onViewImages,
  onEdit,
  onDelete
}) {
  const handleViewImages = (e) => {
    e.stopPropagation();
    onViewImages();
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div className="bottle-card" onClick={onClick}>
      <div className="bottle-card__header">
        <h3 className="bottle-card__name">{bottle.bottle_name}</h3>
        <div className="bottle-card__badges">
          <span className={`bottle-card__status bottle-card__status--${bottle.status.toLowerCase()}`}>
            {bottle.status}
          </span>
        </div>
      </div>

      <div className="bottle-card__type">{bottle.type}</div>

      <div className="bottle-card__details">
        {bottle.distilleries && (
          <p className="bottle-card__distillery">
            {bottle.distilleries.distillery_name}
          </p>
        )}
        <div className="bottle-card__meta">
          {bottle.proof && <span>{formatProof(bottle.proof)}</span>}
          {bottle.age_months != null && <span style={{ whiteSpace: 'nowrap' }}>{formatAge(bottle.age_months)}</span>}
          {bottle.purchase_price && <span>{formatCurrency(bottle.purchase_price)}</span>}
        </div>
      </div>

      <div className="bottle-card__actions">
        <Button size="sm" variant="ghost" onClick={handleViewImages}>
          View
        </Button>
        <Button size="sm" variant="ghost" onClick={handleEdit}>
          Edit
        </Button>
        <Button size="sm" variant="danger" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
}
